module.exports = __webpack_public_path__ + "static/media/perm-makeup-unselected.f64d0a47.png";